import { AlertCircle } from 'lucide-react';
import { FieldShell } from './FieldShell';
import { resolveWidgetKind } from '../helpers';
import type { FieldComponentProps } from './types';

/**
 * Renders a clear placeholder for fields whose widget kind isn't implemented
 * yet. Surfaces the metadata so support can act on it instead of submitting an
 * empty value silently.
 */
export const UnsupportedField = ({ field, error }: FieldComponentProps) => {
  const kind = resolveWidgetKind(field);
  return (
    <FieldShell field={field} error={error}>
      <div className="flex items-start gap-2 rounded-lg border border-amber-200 bg-amber-50 p-3 text-sm text-amber-800">
        <AlertCircle className="h-4 w-4 mt-0.5 flex-shrink-0" />
        <span>
          Field type <code className="font-mono">{kind}</code> ({field.display_type || field.uidt || field.dt})
          is not yet supported in this form. Please reach out to the engineering team.
        </span>
      </div>
    </FieldShell>
  );
};
